import React from "react";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import { ACADEMIC_YEAR, CONTEXT_COMMON_NAME } from "../CommonUtilities/Validations/RegularExpAndVar";
export default function PublicHeader() {
  return (
    <React.Fragment>
      <Navbar expand="lg" className="nav-bg">
        <Container fluid>
          <Navbar.Brand href="#home" className="navbar-brand">{CONTEXT_COMMON_NAME} - {ACADEMIC_YEAR}</Navbar.Brand>
          {/* <Navbar.Toggle aria-controls="basic-navbar-nav" className="border-0" /> */}
          {/* <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <div className="user-icon-box">
                <LuUser2 className="user-icon-top" />
              </div>
              <NavDropdown title="Welcome 15127133" id="basic-nav-dropdown" className="user-login">
                <NavDropdown.Item href="#action/3.1">Login</NavDropdown.Item>
                <NavDropdown.Item href="#action/3.3">LogOut</NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse> */}
        </Container>
      </Navbar>
    </React.Fragment>
  )
}
